import React, { useEffect, useState } from "react";
import { css } from "emotion";
import { stepContent } from "../style";
import Radio from "../../../../../shared/Radio/Radio";
import ButtonLink from "../../../../../../js/components/DynamicForm/components/ButtonLink";
import { GOL_FIDELITY_PROGRAM, Type2FA } from "../../../../../../js/shared/constants";
import { useNewOfferMobile } from "../../context";
import Callout from "../../../../../shared/create-offer/Callout/Callout";
import ModalPhoneTwoFactorAuthentication from "../../../../../shared/create-offer/ModalPhoneTwoFactorAuthentication/ModalPhoneTwoFactorAuthentication";

const TwoFactorMethodSelect = ({ onChangeLoyalty, airlineProgramsSettings, status2FAEnabledFeature, email2FAStatusValidation, offerData }) => {
	const [twoFactorAuthenticationStrategy, setTwoFactorAuthenticationStrategy] = useState("");
	const [showModalTwoFactorAuthenticationPhone, setShowModalTwoFactorAuthenticationPhone] = useState(false);
	const { setStepError } = useNewOfferMobile();

	const updateTwoFactorAuthenticationWhenAlreadyRegistered = strategyType => {
		setTwoFactorAuthenticationStrategy(strategyType);
		onChangeLoyalty({ twoFactorAuthenticationStrategy: strategyType });
	}

	const onChangeRadio = event => {
		const { value } = event;

		if (value === Type2FA.WHATSAPP_CONTACT) {
			setShowModalTwoFactorAuthenticationPhone(true);
		}

		setTwoFactorAuthenticationStrategy(value);
		onChangeLoyalty({ twoFactorAuthenticationStrategy: value });
	}

	useEffect(() => {
		setStepError(!twoFactorAuthenticationStrategy);
	}, [twoFactorAuthenticationStrategy]);

	const { idAirlinesProgram } = airlineProgramsSettings;

	return (
		<div
			className={css`
				${stepContent};
			`}
		>
			{idAirlinesProgram === GOL_FIDELITY_PROGRAM && airlineProgramsSettings && status2FAEnabledFeature && (
				<div className={`box-2fa`}>
					<p className="box-2fa--title box-title">{airlineProgramsSettings.title}</p>
					{airlineProgramsSettings.options.map(item => {
						!twoFactorAuthenticationStrategy && item.selected && updateTwoFactorAuthenticationWhenAlreadyRegistered(item?.type)
						return <div className="row box-2fa__box-radio" key={item.type}>
							<div className="col">
								<p className="box-2fa--paragraph">{item.title} {item.tags.length > 0 && (<span className="box-2fa__badge">{item.tags}</span>)}</p>
								<Radio
									horizontally={false}
									options={[{ value: item.type, label: item.description, checked: !twoFactorAuthenticationStrategy && item.selected || twoFactorAuthenticationStrategy === item.type }]}
									name="twoFactorAuthenticationStrategy"
									value={twoFactorAuthenticationStrategy}
									onChange={onChangeRadio}
								/>
								{item.actions?.length > 0 && (
									<div className="box-2fa__box-radio--small-font">
										{!item.actions[0]?.disabled && (
											<Callout
												show={!twoFactorAuthenticationStrategy && item.selected || twoFactorAuthenticationStrategy === item.type}
												hideIcon={true}
												style={{ borderTop: '1px solid #E2E8F0' }}
												text={
													item.actions[0]?.text && (
														<div className="no-padding-left">
															<span>{item.actions[0]?.text}</span>
															{item.actions[0]?.link && item.actions[0]?.textLink && (
																<div className="mt-16 link-text-decoration-none">
																	<ButtonLink color="green" onClick={() => window.open().location.href = item.actions[0]?.link}>{item.actions[0]?.textLink}</ButtonLink>
																</div>
															)}
															{!item.actions[2]?.disabled && (
																<div className={`mb-16 mt-16`}>
																	{item.actions[2]?.link && item.actions[2]?.textLink && ((!email2FAStatusValidation.isValidated && email2FAStatusValidation.error !== null) || (offerData.data.quant >= item.actions[2]?.minPointsToAlwaysShowButton)) && (
																		<ButtonLink color="green" buttonStyle="outline" onClick={() => window.open().location.href = item.actions[2].link}>{item.actions[2].textLink}</ButtonLink>
																	)}
																</div>
															)}
														</div>
													)
												}
											/>
										)}
										{!item.actions[1]?.disabled && (
											<>
												{item.actions[1]?.text && (
													<Callout
														show={!twoFactorAuthenticationStrategy && item.selected || twoFactorAuthenticationStrategy === item.type}
														hideIcon={true}
														style={{ borderTop: '1px solid #E2E8F0' }}
														text={
															<span>{item.actions[1]?.text}</span>
														}
													/>
												)}
												{item.actions[1]?.link && item.actions[1]?.textLink && (
													<div className="col-xs-16 mb-16">
														<ButtonLink color="green" onClick={() => window.open().location.href = item.actions[1].link}>{item.actions[1].textLink}</ButtonLink>
													</div>
												)}
											</>

										)
										}
									</div>
								)}
							</div>
						</div>
					})}
				</div>
			)}
			<ModalPhoneTwoFactorAuthentication
				show={showModalTwoFactorAuthenticationPhone}
				onConfirm={() => setShowModalTwoFactorAuthenticationPhone(false)}
			/>
		</div>
	);
};

export default TwoFactorMethodSelect;
